import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { BoilersBootstrapModule } from './lib/boilers.bootstrap.module';

const loadChildren = () =>
  import('./lib/boilers.lazy.module').then(
    (module) => module.BoilersLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const boilersLazyImports: ComponentNameAndModule[] = [
  defineImport('BoilerAdviceForm'),
];

export { boilersLazyImports, BoilersBootstrapModule };
export { selectBoilerProductAction } from './lib/store/boilers.actions';
